export { default as khc } from './khc';
